import React, { useEffect, useState } from "react";
import {
  Content,
  Row,
  Col,
  Box,
  Button,
  SimpleTable,
  Pagination,
  Alert
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import controllerServicios from "../servicios/duck";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../utils/Loader";

function ServiciosPadresList({ history, match }) {
  const dispatch = useDispatch();

  const modelServiciosPadre = useSelector((state) => state.serviciosPadre);
  const modelDelete = useSelector((state) => state.deleteSubcategoria);

  const [serviciosPadre, setServiciosPadre] = useState(null);
  const [totalResultsServPadre, setTotalResultsServPadre] = useState(0);
  const [activePageServPadre, setActivePageServPadre] = useState(0);
  const [pageSizeServPadre, setPageSizeServPadre] = useState(5);

  useEffect(() => {
    const data = modelDelete?.data?.data;
    const error = modelDelete?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controllerServicios.duckDeleteSubcategoria.actions.clear());
    }
    if (data) {
      handlePageServPadre(0);
      dispatch(controllerServicios.duckDeleteSubcategoria.actions.clear());
    }
  }, [modelDelete]);

  useEffect(() => {
    const data = modelServiciosPadre?.data?.data;
    const error = modelServiciosPadre?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckServiciosPadre.actions.clear());
    }
    if (data) {
      setServiciosPadre(data.data.items);
      setTotalResultsServPadre(data.data.total);

      dispatch(controller.duckServiciosPadre.actions.clear());
    }
  }, [modelServiciosPadre]);

  useEffect(() => {
    dispatch(
      controller.serviciosPadreThunk(
        match.params.organizacion,
        1,
        pageSizeServPadre
      )
    );
  }, []);

  function handlePageServPadre(page) {
    setActivePageServPadre(page);
    setServiciosPadre([]);
    dispatch(
      controller.serviciosPadreThunk(
        match.params.organizacion,
        page + 1,
        pageSizeServPadre
      )
    );
  }

  function eliminarSubcategoria(id, name) {
    var answer = window.confirm(
      `Borrar ${name} eliminará toda la información guardada del servicio. ¿Está seguro que desea eliminarlo?`
    );
    if (answer) {
    
      let datos = {
        id,
      };

      dispatch(controllerServicios.deleteSubcategoriaThunk(datos));
    }
  }

  
  return (
    <Content
      title="Subcategorías"
      browserTitle="Subcategorías"
      show={false}
    >
      <Row>
        <Col md="12">
          <Box title="Lista">
          <Col md="12">
              <Alert type="warning" title="Aviso">
                <p>
                  Para acceder a los servicios de clic en el nombre.
                </p>
              </Alert>
            </Col>
            <Button
              type="primary"
              text="Agregar"
              pullRight={true}
              onClick={() =>
                history.push(`/nuevoServicioPadre/${match.params.organizacion}`)
              }
            />
            <div>
              <span>Total: {totalResultsServPadre}</span>
            </div>
            <Loader isLoading={modelServiciosPadre.loading}>
              {serviciosPadre && serviciosPadre.length > 0 ? (
                <SimpleTable
                  hover={true}
                  data={serviciosPadre.map((row, index) => {
                    return {
                      nombre: (
                        <a
                        style={{
                          cursor: "pointer",
                        }}
                          onClick={() =>
                            history.push(
                              `/serviciosHijosList/${match.params.organizacion}/${row._id}/${match.params.categoria}`
                            )
                          }
                        >
                          {row.nombre}
                        </a>
                      ),
                      estado: row.estado,
                      editar: (
                        <Button
                          type="primary"
                          text="Editar"
                          onClick={() =>
                            history.push(`/editSubcategoria/${row._id}`)
                          }
                        />
                      ),
                      eliminar: (
                        <Button
                          type="danger"
                          text="Eliminar"
                          onClick={() => eliminarSubcategoria(row._id, row.nombre)}
                        />
                      ),
                    };
                  })}
                  columns={[
                    { title: "Nombre", data: "nombre" },
                    { title: "Estado", data: "estado" },
                    { title: "Editar", data: "editar" },
                    { title: "Eliminar", data: "eliminar" },
                  ]}
                />
              ) : (
                <h4>No se han encontrado servicios</h4>
              )}
            </Loader>
            <Pagination
              activePage={activePageServPadre}
              pageSize={pageSizeServPadre}
              totalElements={totalResultsServPadre}
              onChange={handlePageServPadre}
              labels={{
                first: "Primera",
                last: "Última",
                previous: "Anterior",
                next: "Siguiente",
              }}
            />
            <div>
              <span>Total: {totalResultsServPadre}</span>
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default ServiciosPadresList;
